<template>
  <PageView :main-title="$t(`actualitesPage.title-national`)">
    <ActualitesView />
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import PageView from "@/views/commons/PageView.vue"
import ActualitesView from "@/views/grae/ActualitesView.vue"

export default defineComponent({
  name: "ActualitesNationalesPage",
  components: {
    PageView,
    ActualitesView,
  },
})
</script>
